import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b5df66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container login-error-modal" }
const _hoisted_2 = { class: "login-error-modal d-flex justify-content-center align-items-center" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_AsahiTypography, { type: "headline-medium" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.message), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}